"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var AccountContext = /*#__PURE__*/_react["default"].createContext({
  user: null,
  parentRoute: null,
  name: "user",
  page: "",
  statusManager: null,
  documentName: "document",
  termsSlug: "terms",
  privacySlug: "privacy",
  acceptTermsPropertyName: "acceptTerms",
  acceptPrivacyPropertyName: "acceptPrivacy"
});
var _default = AccountContext;
exports["default"] = _default;